module.exports = __webpack_public_path__ + "assets/6a6116882e45a6b25d635e25b6f95622.png";